import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MessageResponse } from '@core/models/interfaces/message_response.interface';

@Injectable({ providedIn: 'root' })
export class SubscriptionHttpService {
  API_URL = `${ environment.api_host }/api/subscription`;

  constructor(private http: HttpClient) {
  }

  cancelSubscription(): Observable<MessageResponse> {
    return this.http.post<MessageResponse>(`${ this.API_URL }/cancel`, {});
  }

  startPayment(): Observable<MessageResponse> {
    return this.http.post<MessageResponse>(`${ this.API_URL }/start-payment`, {});
  }
}
